import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NuevaCampaniaPage } from './nueva-campania';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    NuevaCampaniaPage,
  ],
  imports: [
    IonicPageModule.forChild(NuevaCampaniaPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class NuevaCampaniaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/nueva-campania/nueva-campania.module.ts